<ng-template #modalContentTemplate>
  <p class="modal-text body--xs udex-mb-16 udex-mb-sm-20">
    {{'checkout.existingCustomerAgreement' | cxTranslate}}
  </p>

  <dcp-additional-required-solution
    [additionalSolutions]="orderEntriesOneParent"
    [priceData]="priceData"
  ></dcp-additional-required-solution>
  <dcp-additional-required-solution
    [additionalSolutions]="orderEntriesSomeParents"
    [priceData]="priceData"
    [headline]="'checkout.someItemsInThisGroup' | cxTranslate"
    showToolTipContent="true"
  ></dcp-additional-required-solution>
  <dcp-additional-required-solution
    [additionalSolutions]="orderEntriesAllParents"
    [priceData]="priceData"
    [headline]="'checkout.allItemsInThisGroup' | cxTranslate"
  ></dcp-additional-required-solution>
  <div>
    <udex-divider class="block udex-pb-8 udex-pb-sm-12"></udex-divider>
    <div class="d-flex justify-content-end">
      <h3 class="modal-price body--xs">
        {{derivativePrice}}
      </h3>
    </div>
  </div>
</ng-template>
